import gsap from 'gsap';
import ScrollMagic from 'scrollmagic';

/**
 * Когда GSAP анимирует числа, он автоматически округляет их
 * до 4 знаков после запятой. В нашем случае нужно больше знаков,
 * поэтому используем такой плагин, чтобы обойти это:
 * https://greensock.com/forums/topic/25830-tweening-value-with-large-number-of-decimals/
 */
gsap.registerPlugin({
    name: 'precise',
    init(target, vars, tween, index, targets) {
        let data = this,
            p, value;
        data.t = target;
        for (p in vars) {
            value = vars[p];
            typeof (value) === 'function' && (value = value.call(tween, index, target, targets));
            data.pt = { n: data.pt, p: p, s: target[p], c: value - target[p] };
            data._props.push(p);
        }
    },
    render(ratio, data) {
        let pt = data.pt;
        while (pt) {
            data.t[pt.p] = pt.s + pt.c * ratio;
            pt = pt.n;
        }
    }
});

export class Counter {
    constructor(el) {
        this.container = el;
        this.placeholder = this.container.querySelector('.js-counter-value');
        this.number = +this.placeholder.getAttribute('data-value').replace(',', '.');
        this.numberIsInteger = Number.isInteger(this.number);
        this.smController = new ScrollMagic.Controller();
        this.bindScroll();
    }

    /**
     * Запускаем анимацию, когда доскроллили до счётчика
     */
    bindScroll() {
        new ScrollMagic.Scene({
            triggerElement: this.container,
            triggerHook: 0.75,
            offset: 0,
            duration: 0,
            reverse: false
        })
            .on('enter', () => this.animate())
            .addTo(this.smController);
    }

    /**
     * Анимируем число в счётчике
     */
    animate() {
        const num = { val: 0 };

        this.container.classList.add('_is-animated');

        gsap.to(num, {
            duration: 1,
            ease: 'power1.out',
            precise: {
                val: this.number,
            },
            onUpdate: () => {
                if (this.numberIsInteger) {
                    /**
                     * Для целых чисел (€ 2200) не показываем промежуточные
                     * значения с дробными
                     */
                    this.placeholder.innerText = this.formatThousands(Math.floor(num.val));
                } else {
                    /**
                     * Для дробных чисел (₿ 0,123125) выводим с запятой (вместо точки)
                     */
                    this.placeholder.innerText = parseFloat(
                        num.val.toFixed(6)
                    )
                        .toString()
                        .substr(0, 9)
                        .replace('.', ',');
                }
            }
        });
    }

    /**
     * Разбиение чисел на разряды (1000000 => 1 000 000)
     */
    formatThousands(string) {
        return string ? string.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ') : string;
    }
}

document.querySelectorAll('.js-counter').forEach((el) => {
    new Counter(el);
});
